import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SIZES } from "@/config/site";
import { Reveal, ChapterTag } from "./Reveal";
import { scrollToFormField } from "@/lib/scroll";

export const SizesSection = () => {
  const consult = (sizeLabel) => {
    window.dispatchEvent(new CustomEvent("prefill-size", { detail: sizeLabel }));
    scrollToFormField();
  };

  return (
    <section id="tamanos" data-testid="sizes-section" className="py-16 sm:py-20 bg-brand-paper">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <ChapterTag num="01" label="Tamaños y precios" />
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mt-5">
            <div>
              <h2 className="font-display font-extrabold tracking-tight text-brand-ink text-3xl sm:text-4xl lg:text-5xl">
                ¿Cuánto espacio necesitas?
              </h2>
              <p className="mt-3 text-base sm:text-lg text-brand-ink/60 max-w-xl">
                Encuentra el trastero que mejor encaja contigo. Precios de apertura, sin compromiso.
              </p>
            </div>
            <p className="inline-flex items-center self-start lg:self-auto gap-2 font-mono text-[11px] sm:text-xs font-bold tracking-[0.12em] uppercase text-brand-ink bg-brand-yellow/70 border border-brand-yellow px-4 py-2.5 rounded-full">
              Prerreserva: descuento en tu primer mes
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
          {SIZES.map((size, i) => (
            <motion.article
              key={size.id}
              data-testid={`size-card-${size.id}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -6 }}
              className="group bg-white rounded-2xl border border-brand-ink/8 overflow-hidden shadow-[0_2px_12px_rgba(18,19,22,0.05)] hover:shadow-[0_18px_45px_rgba(18,19,22,0.11)] transition-shadow duration-300 flex flex-row sm:flex-col"
            >
              <div className="relative w-32 shrink-0 sm:w-full sm:aspect-[16/8] overflow-hidden">
                <img
                  src={size.img}
                  alt={`Trastero de ${size.label} en Guadalajara`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 font-mono text-[10px] font-bold tracking-[0.2em] bg-brand-ink text-brand-yellow px-2.5 py-1 rounded-full">
                  {size.num}
                </span>
                <span
                  data-testid={`size-card-price-${size.id}`}
                  className="absolute bottom-3 right-3 inline-flex items-baseline gap-1 whitespace-nowrap bg-brand-ink/90 backdrop-blur-sm text-white px-2.5 py-1.5 sm:px-3.5 sm:py-2 rounded-full"
                >
                  <span className="font-mono text-[8px] sm:text-[9px] font-bold tracking-[0.18em] uppercase text-white/55">desde</span>
                  <span className="font-display font-black text-base sm:text-lg leading-none text-brand-yellow">{size.price} €</span>
                  <span className="font-mono text-[8px] sm:text-[9px] font-bold text-white/55">/mes</span>
                </span>
              </div>
              <div className="p-4 sm:p-5 flex flex-col flex-1">
                <div className="flex items-baseline justify-between gap-3">
                  <h3 className="font-display font-extrabold text-xl text-brand-ink tracking-tight">
                    {size.label}
                  </h3>
                </div>
                <p className="mt-1.5 text-[13px] text-brand-ink/60 leading-snug flex-1">{size.desc}</p>
                <button
                  data-testid={size.testid}
                  onClick={() => consult(size.label)}
                  className="mt-4 inline-flex items-center justify-between w-full border-2 border-brand-ink text-brand-ink font-display font-bold text-xs tracking-wide px-4 py-2.5 rounded-full group-hover:bg-brand-yellow group-hover:border-brand-yellow transition-[background-color,border-color] duration-300"
                >
                  APUNTARME A LA APERTURA
                  <ArrowUpRight size={15} strokeWidth={2.6} />
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
